export enum IntervalElementStatus {
  Available = "Available",
  NonAvailable = "Non-Available",
}
